// Auto generated file, do not manually modify!
// com.hotpads.leasing.client.enums.LeaseActionRestrictionType

export enum LeaseActionRestrictionType {
  ARCHIVED_TEMPLATE_NO_REPLACEMENT = 'ARCHIVED_TEMPLATE_NO_REPLACEMENT',
  LEGACY_UPGRADE_TO_COSMOS = 'LEGACY_UPGRADE_TO_COSMOS',
}

export const LeaseActionRestrictionType_values = [
  LeaseActionRestrictionType.ARCHIVED_TEMPLATE_NO_REPLACEMENT,
  LeaseActionRestrictionType.LEGACY_UPGRADE_TO_COSMOS,
] as const;
